import axios from 'axios';
import { refreshTokenRequest } from './authRefresh.js';

// New Mech API axios instance
export const axiosNewMechInstance = axios.create({
  baseURL: 'https://api.mech.vin/',
});

export const setJWTAuthHeader = token => {
  const header = `Bearer ${token}`;

  axiosNewMechInstance.defaults.headers.common['Authorization'] = header;
  axiosNewMechInstance.defaults.headers.common['Authorization'] = header;
};

export const clearJWTAuthHeader = () => {
  delete axiosNewMechInstance.defaults.headers.common['Authorization'];
  delete axiosNewMechInstance.defaults.headers.common['Authorization'];
};

let isRefreshing = false;
let failedQueue = [];
let isLoggingOut = false;

const processQueue = (error, token = null) => {
  failedQueue.forEach(p => (error ? p.reject(error) : p.resolve(token)));
  failedQueue = [];
};

axiosNewMechInstance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    const refreshToken = localStorage.getItem('refreshToken');

    if (!refreshToken || refreshToken === 'undefined') {
      return Promise.reject(error);
    }

    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry &&
      !originalRequest.url.includes('/auth/refresh')
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axiosNewMechInstance(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newToken = await refreshTokenRequest();

        processQueue(null, newToken);

        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        return axiosNewMechInstance(originalRequest);
      } catch (err) {
        processQueue(err, null);

        if (!isLoggingOut) {
          isLoggingOut = true;

          clearJWTAuthHeader();
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');

          window.location.replace('/login');
        }

        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);
